<template>
    <span class="text-success ml-1" v-if="mostrarIcone">
        <i
            class="fa fa-check-circle fa-lg"
            title="Processo Recebido/Quitado"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {}
    },

    methods: {},

    computed: {
        mostrarIcone() {
            return this.status == 'F' || this.status == 'Q'
        }
    }
}
</script>
